angular.module('env.data.models.centreModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CentreModel",
            {
                extend: ['BaseModel'],
                url: "centres",
                fields: {
                    addressId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    address: {
                        subResource: true,
                        get: function (rest, model) {
                            if (model.$model.addressId) {
                                return rest
                                    .map(rest.getDefinition("AddressModel"))
                                    .map(model.$model.addressId)
                                    .willReturn("AddressModel", model.$model.addressId).get();
                            }
                            return null;
                        }
                    },
                    code: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                }
            }
        );
    })

;